const MEDIATAILOR_ERROR_BASE = 0x1100;
export const MediatailorErrorCodes = Object.freeze({
  /**
   * Indicates that the Yospace session initialization failed
   */
  SESSION_INIT_FAILURE: MEDIATAILOR_ERROR_BASE + 0x01,
  SESSION_DATA_PARSING_FAILURE: MEDIATAILOR_ERROR_BASE + 0x02,
  TRACKING_API_FAILURE: MEDIATAILOR_ERROR_BASE + 0x03,
  DATAZOOM_CONFIG_ID_MISSING: MEDIATAILOR_ERROR_BASE + 0x05,
});
